// removed by extract-text-webpack-plugin
module.exports = {"stage-wrap":"_3Pxa","steps":"_2cTB","succ-icon":"_2Esu","steps-txt":"_1AQl","steps-subtxt":"_3bhr","active":"_Hpjc","prev-active":"_2zO2","cursor":"_2C1W"};


//////////////////
// WEBPACK FOOTER
// ./checkout/components/steps/style.css
// module id = fgEf
// module chunks = 4